import { Box, Skeleton } from "@tm/components"

export function TableLoading({ colCount }: { colCount: number }) {
    return (
        <Box sx={{ gridColumn: `1 / span ${colCount}`, gap: 1, display: "grid", gridTemplateColumns: `repeat(${colCount}, 1fr)` }}>
            {Array.from(new Array(colCount)).map((_, index) => (
                <Skeleton variant="rounded" height={30} key={index} />
            ))}
            <Skeleton variant="rounded" height={50} sx={{ gridColumn: `1 / span ${colCount}` }} />
            <Skeleton variant="rounded" height={50} sx={{ gridColumn: `1 / span ${colCount}` }} />
        </Box>
    )
}
